import { getRoleRank } from '../constants/roles';

/** Most privileged role (lowest rank) across user.roles, falling back to role/accountType. */
export const getBestRole = (user) =>
	user?.roles?.length > 0
		? user.roles.reduce((best, r) => (getRoleRank(r) < getRoleRank(best) ? r : best))
		: user?.role || user?.accountType || 'User';

export const getUserRole = (user) => user?.roles?.[0] ?? user?.role ?? 'User';
